export const routeToUrl = (
  route: string,
  params?: { [key: string]: string | number },
  searchParams?: {
    [key: string]: string | number | readonly (string | number)[] | undefined;
  },
) => {
  let url = route;

  const cleanedParams: { [key: string]: string } = {};

  for (const key in params) {
    cleanedParams[key] = String(params[key]);
  }

  Object.keys(cleanedParams).forEach((param) => {
    url = url.replace(`:${param}`, cleanedParams[param]);
  });

  if (searchParams) {
    const queryParams: string[] = [];
    for (const [key, value] of Object.entries(searchParams)) {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          queryParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        });
      } else if (value !== undefined) {
        queryParams.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(value as string | number)}`,
        );
      }
    }

    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
  }

  return url;
};

/**
 * The method extracts parameters from route string.
 *
 * Example:
 * * for the route: const theRoute = "/merchflows/:merchflowId/s0/:s0UserTriggerId"
 * * we can use type: ExtractRouteParams<typeof theRoute>;
 * * the result type is: { merchflowId: string; s0UserTriggerId: string; }
 */
export type ExtractRouteParams<T extends string> =
  T extends `${string}:${infer Param}/${infer Rest}`
    ? { [K in Param | keyof ExtractRouteParams<`/${Rest}`>]: string }
    : T extends `${string}:${infer Param}`
      ? { [K in Param]: string }
      : unknown;
